import {useStyle, useWindowStyle} from "../../../hooks";
import {AnimatePresence, motion} from "framer-motion";
import {getNodeTypes} from "../../../common/machine/MachineHandler";
import React, {useState} from "react";
import store, {useTypedSelector} from "../../../store";
import {ExecutableNodeTypeListScroller} from "./ExecutableNodeTypeListScroller";
import {getShadowFromStyle} from "../../style";
import {ShadowElement} from "../dialogs/FancyWindow";
import {ExecutableNodeType, nodeInstanceDimensions} from "../../../common/types/nodeTypes";
import {addNode, dragInNode} from "../../../store/nodes";
import {v4 as uuidv4} from "uuid";

export const NodeCategory = ({name, types, onClick, open, onSelectItem}: {
    name: string,
    types: any,
    onClick?: () => any,
    open?: boolean,
    onSelectItem?: (type: ExecutableNodeType, key: string, pckg: string) => any
}) => {
    const style = useWindowStyle();
    const nodeStyle = useStyle();

    //const boxShadow = getShadowFromStyle(style.shadow);
    const {padding} = style.window;

    return <div style={{position: "relative"}}>
        <motion.div
            style={{
                position: "relative",
                cursor: 'pointer',
                color: nodeStyle.palette.default.main,
                fontFamily: 'Roboto Mono',
                fontSize: 13,
                zIndex: 99
            }}
            initial={{opacity: .5}}
            animate={{opacity: open ? 1 : .5, transition: {duration: .15}}}
            onMouseEnter={onClick}
        >
            <div style={{position: "relative", zIndex: 999}}>{name}</div>
            <AnimatePresence>
                {open && <motion.div
                    style={{position: "absolute", inset: 0, zIndex: 998}}
                    initial={{scale: .8, opacity: 0}}
                    animate={{scale: 1, opacity: 1}}
                >
                    <div style={{position: "absolute", inset: -6, background: style.window.transparentBackground, zIndex: 1}}/>
                    <div style={{position: "absolute", bottom: 0, left: 0, width: 0, height: 0, zIndex: 0}}>
                        {/*<div style={{
                        position: "absolute",
                        top: -24,
                        left: -6,
                        width: 132,
                        height: 24,
                        background: style.window.background
                    }}/>*/}
                        <div style={{
                            position: "absolute",
                            top: 6, //-24 + (padding as number * 2),
                            left: -6,
                            width: 240, //332,
                            textAlign: "left",
                            /*borderLeft: padding as number / 2 + "px solid " + style.window.background,
                            borderBottom: padding as number / 2 + "px solid " + style.window.background,
                            borderRight: padding as number / 2 + "px solid " + style.window.background,
                            borderTop: padding as number / 2 + "px solid " + style.window.background*/
                            //boxShadow
                        }}>
                            <ShadowElement opacity={.5}/>
                            <ExecutableNodeTypeListScroller types={{[name]: types}} style={{maxHeight: 440}} onSelectItem={onSelectItem}/>
                        </div>
                    </div>
                </motion.div>}
            </AnimatePresence>
        </motion.div>
    </div>
}

const NodeLibrary = () => {
    let types = getNodeTypes();
    const connectionState = useTypedSelector(state => state.nodes.machineState.connectionState);
    const draggingInNode = useTypedSelector(state => state.nodes.dragInNode);

    const [menu, setMenu] = useState<string | null>(null);

    return types ? <div style={{
        position: 'absolute',
        left: 6,
        top: 4,
        display: "flex",
        flexDirection: "row",
        gap: 24,
        zIndex: 99999,
        //pointerEvents: !!draggingInNode ? 'none' : 'auto'
    }} onMouseLeave={() => setMenu(null)}>
        {Object.keys(types).map(name => <NodeCategory
            key={"node library category " + name}
            open={menu === name}
            onClick={() => {
                setMenu(name);
            }}
            onSelectItem={(type, key, pckg) => {
                let id = uuidv4();
                let {width, height} = nodeInstanceDimensions(type);

                console.log(type);

                store.dispatch(
                    dragInNode({
                        id,
                        type: {name: key, package: pckg},
                        shape: {
                            ...type.instanceDimensions,
                            x: 0,
                            y: 0,
                            width,
                            height
                        },
                        input: type.input.map(() => ({})),
                        output: type.output.map(() => ({})),
                        state: 'initializing'
                    })
                );
            }}
            name={name || "default"}
            types={types[name]}
        />)}
    </div> : null
}

export default NodeLibrary;